/**
 * Validates MessageEvent from navigator.serviceWorker when the sender is this site's SW.
 */
export function isMessageFromOriginServiceWorker(event: MessageEvent): boolean {
  if (typeof window !== 'undefined') {
    const pageOrigin = window.location.origin;
    if (typeof event.origin === 'string' && event.origin.length > 0 && pageOrigin && event.origin !== pageOrigin) {
      return false;
    }
  }
  if (!(event.source instanceof ServiceWorker)) {
    return false;
  }
  try {
    return new URL(event.source.scriptURL).origin === window.location.origin;
  } catch {
    return false;
  }
}

/**
 * Registers `message` on the container with an inline origin/source check (CWE-20).
 * Prefer this over raw `navigator.serviceWorker.addEventListener('message', ...)`.
 */
export function installTrustedNavigatorServiceWorkerMessageListener(
  handler: (event: MessageEvent) => void,
): void {
  if (!('serviceWorker' in navigator)) {
    return;
  }
  navigator.serviceWorker.addEventListener('message', (event: MessageEvent) => {
    if (!isMessageFromOriginServiceWorker(event)) {
      return;
    }
    handler(event);
  });
}
